module.exports = __webpack_public_path__ + "img/34.d2dfe8e8.jpg";